import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class UserManagementService extends AxiosBase {
  addOrganization = async (body) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.ORGANIZATION.ORG}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  // Get all users filter
  getAllUserManagementData = async (page, limit, email, role, navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.USERMANAGEMENT.GET_USERS}?page=${page}&limit=${limit}&email=${email}&role=${role}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getAllUserManagement = async ({
    page,
    limit,
    navigate,
    filterValue,
    searchQuery,
    sortKey,
    sortDirection,
    searchType,
  }) => {
    try {
     const type = searchType
        ? searchType
        : !searchQuery
          ? "name"
          : !isNaN(searchQuery) && searchQuery.trim() !== ""
            ? "contact"
            : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(searchQuery)
              ? "email"
              : "name";
              
      const response = await this.requests.get(
        `${
          API_ROUTES.USERMANAGEMENT.GET_USERS
        }?page=${page}&limit=${limit}&status=${filterValue}&${type}=${encodeURIComponent(
          searchQuery
        )}&sortKey=${sortKey}&sortDirection=${sortDirection}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  // get all roles
  getAllRoles = async (navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.USERMANAGEMENT.GET_ROLES}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  // get all roles
  getAllPermissions = async (navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.USERMANAGEMENT.GET_ALL_PERMISSIONS}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  // delete user
  deleteUser = async (id, page, limit, navigate, filterValue) => {
    try {
      const response = await this.requests.delete(
        `${API_ROUTES.USERMANAGEMENT.DELETE_USER.replace(":id", id)}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  // delete multiple users
  deleteMultipleUsers = async (userIds, page, limit, navigate, filterValue) => {
    try {
      const response = await this.requests.delete(
        API_ROUTES.USERMANAGEMENT.DELETE_MULTIPLE_USERS,
        { userIds }
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  // send email verification reminder
  sendReminderEmail = async (id, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.USERMANAGEMENT.SEND_REMINDER_EMAIL.replace(":id", id)}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  addNewUser = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.USERMANAGEMENT.ADD_NEW_USER}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  uploadUserBulk = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.USERMANAGEMENT.UPLOAD_USER_BULK}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  updateUser = async (id, data, navigate) => {
    try {
      const response = await this.requests.patch(
        `${API_ROUTES.USERMANAGEMENT.UPDATE_USER.replace(":id", id)}`,
        data
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
}
